module.exports = __webpack_public_path__ + "img/la_bruyere.ed588e5d.jpeg";